import {
  CustomTypography,
  ExpandedWrapper,
  StyledProfitItem,
  StyledUserItem,
  TableTotalWrapper,
  StyledWrapper,
} from '@/components/features/casino/crash/PlayerBox/styles';
import { ShowGameMemberItem } from '@/components/features/casino/crash/types/crash';
import VirtualizedTable, {
  ColumnData,
} from '@/components/ui/WrappedTable/VirtualizedTable';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import PeopleIcon from '@mui/icons-material/People';
import { CasinoPerson as PeopleIcon } from '@crownbit/icons';
import { Box, Typography, useMediaQuery, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { useMemberList } from './useCrashMember';
import { StyledTokenIcon } from '@/components/ui/common/TokenIcon';
import { formatMoneyByCurrency } from '@/utils';
import { floorToN } from '@/components/features/casino/crash/GameBox/utils';
import { Add } from '@/utils/decimal/operations';
import { currentCurrencyState } from '@/state/userInfo';
import { useAtomValue } from 'jotai';
import MoneyWithCurrencyIcon from '@/components/biz/MoneyWithCurrencyIcon';

// import { formatCurrency } from '@coingecko/cryptoformat';
export function getPlayerTableColumn(t, firstMember = null) {
  const columns: ColumnData<ShowGameMemberItem>[] = [
    {
      width: 82,
      title: t('Player'),
      dataKey: 'showPlayer',
      align: 'left',
      render: (index, value, row) => {
        const showTooltip = value?.length >= 10;
        return (
          <StyledUserItem>
            {/*{row.showPlayer !== 'hidden' ? '' : <PeopleIcon />}*/}
            {showTooltip ? (
              <Tooltip title={value} arrow>
                <Typography
                  component="span"
                  sx={{
                    color: (theme) =>
                      row?.isCurrentUser
                        ? theme.palette.primary.main
                        : theme.palette.text.primary,
                  }}
                  variant="body2"
                >
                  {value}
                </Typography>
              </Tooltip>
            ) : (
              <Typography
                sx={{
                  color: (theme) =>
                    row?.isCurrentUser
                      ? theme.palette.primary.main
                      : theme.palette.text.primary,
                }}
                variant="body2"
              >
                {value}
              </Typography>
            )}
          </StyledUserItem>
        );
      },
    },
    {
      width: 45,
      title: t('Bet'),
      dataKey: 'showBet',
      numeric: true,
      align: 'center',
    },
    {
      width: 45,
      title: '@',
      dataKey: 'cashOutAt',
      align: 'right',
      render: (index, value, row) => {
        return (
          <span>
            {Number(value) == 0 ? '-' : <span>{floorToN(value, 2) + 'x'}</span>}
          </span>
        );
      },
    },

    {
      width: 95,
      title: t('Profit'),
      dataKey: 'showProfit',
      align: 'right',
      numeric: true,
      render: (index, value, row) => {
        return (
          <StyledProfitItem green={value !== '-'}>
            <MoneyWithCurrencyIcon value={value} currency={row.currency} />
          </StyledProfitItem>
        );
      },
    },
  ];
  return columns;
}

export const PlayerBox: React.FC = () => {
  const theme = useTheme();
  const isMob = useMediaQuery(theme.breakpoints.down('lg'));
  const { t } = useTranslation();

  const currentCurrency = useAtomValue(currentCurrencyState);

  const [loading, setLoading] = React.useState<boolean>(false);
  const { memberList } = useMemberList();
  // highlight current user when has bet
  const playerList = React.useMemo(() => {
    const curBetUserIndex = memberList.findIndex(
      (item) => item.currentUserIsBet,
    );
    if (curBetUserIndex !== -1) {
      return [
        memberList[curBetUserIndex],
        ...memberList.slice(0, curBetUserIndex),
        ...memberList.slice(curBetUserIndex + 1),
      ];
    } else {
      return memberList;
    }
  }, [memberList]);

  const columns = getPlayerTableColumn(t);

  const playerCount = React.useMemo(() => {
    return memberList.length;
  }, [memberList]);
  //TODO: 不同货币单位统一的问题
  const totalAmount = React.useMemo(() => {
    return memberList
      .map((item) => item.amount)
      .reduce((prev, cur) => Add(prev, cur), 0);
  }, [memberList]);

  const [expanded, setExpanded] = React.useState<boolean>(true);
  const toggleExpand = () => {
    setExpanded(!expanded);
  };
  const playerBoxHeight = isMob ? '320px' : '566px';

  return (
    <StyledWrapper
      sx={{
        height: expanded ? playerBoxHeight : '90px',
        [theme.breakpoints.down('lg')]: {
          height: expanded ? playerBoxHeight : '90px',
        },
      }}
    >
      <TableTotalWrapper>
        <CustomTypography variant="body2">
          <PeopleIcon
            fontSize={'small'}
            style={{
              color: 'rgba(255,255,255,0.45)',
            }}
          />
          {playerCount}
        </CustomTypography>
        <CustomTypography variant="subtitle2">
          <span>
            {formatMoneyByCurrency(totalAmount, { currency: currentCurrency })}
          </span>
          <StyledTokenIcon />
          {isMob && <KeyboardArrowDownIcon onClick={toggleExpand} />}
        </CustomTypography>
      </TableTotalWrapper>
      <ExpandedWrapper className={'player-box-wrapper'}>
        <VirtualizedTable
          loading={loading}
          data={playerList}
          columns={columns}
          height={'100%'}
        />
      </ExpandedWrapper>
    </StyledWrapper>
  );
};

export default PlayerBox;
